<template>
    <div
        class="CBackButton"
        :class="{
            'flex items-center [&.xl:min-w-[1271px]:left-[-60px]] absolute left-[-84px] top-0 sm:left-[-50px] xl:left-[-50px]': fixedTop && !label,
            'mb-6': !!label
        }"
    >
        <a
            v-if="label"
            href="#"
            class="inline-flex items-center text-gray-600 dark:text-txt-body hover:text-primary-500"
            @click.prevent="goBack"
        >
            ← {{ label }}
        </a>
        <CButton v-else icon="back" variant="link" @click.prevent="goBack" />
    </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw as RawLocation } from 'vue-router'

const router = useRouter()
const route = useRoute()

interface Props {
    to?: RawLocation
    fixedTop?: boolean
    label?: string
}

const props = defineProps<Props>()

function goBack() {
    // Store scroll target from hash (e.g. #r-id-milan-markovic → r-id-milan-markovic)
    if (import.meta.client) {
        const hash = typeof props.to === 'object' && 'hash' in props.to
            ? props.to.hash
            : undefined
        if (hash) {
            sessionStorage.setItem('scrollToCard', hash.replace('#', ''))
        }
    }

    if (import.meta.client && window.history.length > 1) {
        router.back()
    } else if (props.to) {
        router.push(props.to)
    } else {
        router.back()
    }
}
</script>
